import { useReducer } from "react";

//productArrayList
// const productArrayList = {
//   id: "",
//   name: "",
//   price: "",
//   total: "",
// };
export const initialValue = {
  defaultProduct: false,
  billingParam: { period: "month", unit: 1 },
  promoCoupon: [],
  product_array: [],
  is_packaging_check: false,
  extraMilesCall: false,
  type_change: false,
  collectionRetrun: { return_date: "" },
  containerList: [
    {
      id: "20ft Non-Ele",
      type: "NON",
    },
  ],
  containerListSelect: "20ft Non-Ele",
};

const reducer = (state = initialValue, action) => {
  switch (action.type) {
    case "SET_DATA":
      console.log("action", action);

      return { ...state, ...action.data };
    // Replace the promo coupon list outright (e.g. clearing before applying a
    // default coupon).
    case "SET_PROMO_COUPON":
      return { ...state, promoCoupon: Array.isArray(action.value) ? action.value : [] };
    // Append one resolved coupon to whatever the list holds *now*, rather than
    // to a snapshot taken before the lookup was sent — two coupons applied in
    // quick succession would otherwise each replace the list and lose the
    // other. Ignores a coupon already present.
    case "ADD_PROMO_COUPON": {
      const current = Array.isArray(state.promoCoupon) ? state.promoCoupon : [];

      if (!action.value || current.some((coupon) => coupon?.id === action.value?.id)) {
        return state;
      }

      return { ...state, promoCoupon: [...current, action.value] };
    }
    case "RESET_DATA":
      return initialValue;
    default:
      return state;
  }
};

export const useContextState = (initial) => {
  const [state, dispatchReducer] = useReducer(reducer, initial || initialValue);

  return { state, dispatchReducer };
};
